(function ($) {
  DJ.addBehavior('datepickerYear', '.datepicker-year', {
    attach: function () {
      const datepickerWrapper = this;
      const datepicker = datepickerWrapper.querySelector('input');
      const minDate = datepicker.dataset.min;
      const maxDate = datepicker.dataset.max;

      $(datepicker).datetimepicker({
        viewMode: 'years',
        format: 'YYYY',
        showTodayButton: true,
        minDate: minDate,
        maxDate: maxDate,
        icons: {
          previous: '',
          next: '',
          today: 'today',
        }
      });
    }
  });
})(jQuery);
